import classNames from 'classnames'
import _ from 'lodash'
import Translate from 'modules/local/Translate'
import React, {useMemo} from 'react'
import {NullAsDefault, renderIf} from 'views/Shared'
import {FiChevronsRight} from "react-icons/fi";
import {Link} from "react-router-dom";
import useTranslate from "../../../modules/local/useTranslate";


const Chervron = ({title}) => (
    <React.Fragment>
        <span className="pr-1">{title}</span>
        <FiChevronsRight className="my-auto"/>
    </React.Fragment>
)

const SeeMore = ({
                     to,
                     className,
                     title = 'see more',
                     Component = Link,
                     renderItem = (render) => render(),
                 }) => {
    const t = useTranslate()
    const more = useMemo(() => <Chervron title={t(title)}/>, [])
    const render = useMemo(
        () => (props) =>
            (
                <Component
                    className="flex cursor-pointer no-underline"
                    to={to ?? '#'}
                    {...props}>
                    {more}
                </Component>
            ),
        [to]
    )

    return (
        <div className={classNames('bottom-0 flex w-full', className)}>
            <div className="py-1 px-3 flex-wrap flex w-full justify-center text-color-300 italic text-xs">
                <div className="flex-1"/>
                {renderItem(render)}
            </div>
        </div>
    )
}

const renderLimitLoadMore = ([limit, setLimit, params = {}]) => {
    const {Component = 'div', ...props} = params
    return renderIf(limit > 0, (__, ___, data, nextUrl) => {
        const items = Array.from(_.get(data, 'response.data.data') ?? [])
        return renderIf(
            nextUrl || items.length,
            <SeeMore
                Component={Component}
                renderItem={(render) =>
                    render({
                        onClick: () => {
                            setLimit(0)
                        },
                    })
                }
                {...props}
            />
        )
    })
}

export const renderShowMore = ([limit = 0, setLimit = NullAsDefault], {center = false, className, buttonClassName = 'text-xs italic text-color-400 hover:text-color-100', title = 'show more'} = {}) => (fetch_data, record) => {

    const {links, count = 0} = record ?? {}

    return renderIf(
        _.some([limit > 0 && count > limit, links?.next], Boolean),
        <Translate>
            {(t) => (
                <div className={classNames('w-full flex bottom-0', className)}>
                    <div className="flex-1"/>
                    <div
                        className={classNames(
                            "py-1 px-3 cursor-pointer",
                            buttonClassName
                        )}
                        onClick={() => {
                            if (limit > 0) {
                                setLimit(0)
                            }
                            fetch_data()
                        }}>
                        {`${_.isString(title) ? t(title) : title}\u2026`}
                    </div>
                    {center === true && <div className="flex-1"/>}
                </div>
            )}
        </Translate>
    )
}

export default renderLimitLoadMore
